export default __webpack_public_path__ + "static/media/secon1.2dd3f8d3.jpg";